<template>
    <div class="box-second">
        <p class="title">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>现场管理</el-breadcrumb-item>
                <el-breadcrumb-item>项目监控</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main">
             <div class="content-mon">
                <iframe width="100%" height="100%" :src='myURL' style="border: 0;height: 100%;"></iframe>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../untils/util'
import myHttp from '../../untils/port'
export default {
    data(){
        return{
            groupId:'',
            myURL:''
        }
    },
    mounted(){
        if(util.session.get('roleId')=='4'){
            this.groupId = util.session.get('groupId')
        }else{
            this.groupId = util.session.get('proId')
        }
        //this.groupId = util.session.get('groupId')
        this.myURL = './monitor/view/single.html?id='+this.groupId;
        this.getData();
    },
    methods:{
        //获取数据
        getData(){
            var that = this
            myHttp.getCameraList({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=="200"){
                    var list = resp.data.data.monitorList||[];
                    if(list.length>0&&list[0].machType=='2'){
                        that.myURL = './daHua/hls.html?id='+that.groupId;
                    }
                }else{

                }
            });
        },
    }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        overflow: hidden;
    }
    .content-mon{
        height: 100%;
        width: 100%;
        background: #fff;
    }
</style>